import { createSlice } from '@reduxjs/toolkit';
import { AuthSliceType } from './types';

const initialState: AuthSliceType = {
    userInfo: {
        isLoggedIn: false,
    },
    splashLoading: true,
    error: '',
    userSettings: null,
    userDefaultFilters: null,
    defaultFilters: {
        items: [],
        document_id: '',
    },
    redirectAfterLogin: null,
};

export const authSlice = createSlice({
    name: 'authSlice',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.userInfo = { ...action.payload };
        },
        changeSplashScreen: (state, action) => {
            state.splashLoading = action.payload;
        },
        setUserSettings: (state, action) => {
            state.userSettings = action.payload;
        },
        setUserDefaultFilters: (state, action) => {
            if (state.userDefaultFilters) {
                state.userDefaultFilters = {
                    ...state.userDefaultFilters,
                    ...action.payload,
                };
            } else {
                state.userDefaultFilters = action.payload;
            }
        },
        setDefaultFilters: (state, action) => {
            state.defaultFilters = action.payload;
        },
        setRedirectAfterLogin: (state, action) => {
            state.redirectAfterLogin = action.payload;
        },
    },
});

export const {
    setUser,
    changeSplashScreen,
    setUserSettings,
    setUserDefaultFilters,
    setDefaultFilters,
    setRedirectAfterLogin,
} = authSlice.actions;

export default authSlice.reducer;
